import React from 'react';
import { Drawer } from '@silverfort/sf-components';
import { CustomExposureConfig, SaveExposuresConfigPayload } from '../types';
import { AD_ENTITY_TYPES } from '@silverfort-nodelibs/common/utils/consts';
import CustomExposureConfigurationContent from './CustomExposureConfigurationContent';

interface CreateCustomInsightDrawerProps {
    isOpen: boolean;
    onClose: () => void;
    onSave: (config: SaveExposuresConfigPayload) => void;
    onDelete: (id: string) => void;
    customExposureConfig: CustomExposureConfig;
    isNew?: boolean;
    isSaving?: boolean;
}

const CustomExposureConfigurationDrawer: React.FC<CreateCustomInsightDrawerProps> = ({
    isOpen,
    onClose,
    onSave,
    onDelete,
    customExposureConfig,
    isNew = false,
    isSaving = false
}) => {
    return (
        <Drawer
            anchor="right"
            className="max-w-[50vw]"
            contentClassName="!min-w-[524px] max-w-[524px] p-[0px]"
            footerActionTitle="Apply"
            headerTitle={
                customExposureConfig?.entityType === AD_ENTITY_TYPES.USER
                    ? 'Custom User Exposure'
                    : 'Custom Server Exposure'
            }
            onClose={onClose}
            open={isOpen}>
            {customExposureConfig && (
                <CustomExposureConfigurationContent
                    config={customExposureConfig}
                    onSave={onSave}
                    onDelete={onDelete}
                    isNew={isNew}
                    isSaving={isSaving}
                />
            )}
        </Drawer>
    );
};

export default CustomExposureConfigurationDrawer;
